/**
 * const.ts 类型定义
 */

export const PERF_HOSTS = {
    production: "https://frontend-perf-service.e.kuaishou.com",
    development: "https://frontend-perf-service.test.gifshow.com",
};

/**
 * subtag枚举，为了规范化上报尽量使用预置枚举类型，不能满足需求联系 @zhaizhe 添加
 */
export enum SUBTAG {
    /**
     * 性能监控
     */
    PERF = "PERF",
    /**
     * API错误
     */
    API_ERROR = "API_ERROR",
    /**
     * birdge错误
     */
    BRIDGE_ERROR = "BRIDGE_ERROR",
    /**
     * nginx错误
     */
    NGINX_ERROR = "NGINX_ERROR",
    /**
     * 代码逻辑错误
     */
    LOGIC_ERROR = "LOGIC_ERROR",
    /**
     * 接口时长数据
     */
    API_TIME = "API_TIME",
    /**
     * 用户操作时长数据
     */
    OPERATION_TIME = "OPERATION_TIME",
    /**
     * PV/曝光类统计事件
     */
    PV_STATISTIC = "PV_STATISTIC",
    /**
     * 用户操作类统计事件
     */
    OPREATION_STATISTIC = "OPREATION_STATISTIC",
    /**
     * 自定义
     */
    CUSTOM = "CUSTOM",
}

export interface IPerfLog {
    /**
     * 建议优先使用SUBTAG枚举类型，不满足语义则使用自定义string
     */
    subtag: SUBTAG | string;
    millis?: number;
    extra1?: string;
    extra2?: string;
    extra3?: string;
    extra4?: string;
    extra5?: string;
    extra6?: string;
}

// 用户调用trace

/**
 * Log规范，如果不能满足需求找sdk维护人添加 @zhaizhe
 */
export interface ITraceLog {
    /**
     * api路径 kuaishou.com/rest
     */
    api?: string;
    /**
     * 接口请求用时 ms
     */
    apiTime?: number;
    /**
     * 接口请求参数
     */
    apiParam?: string;
    /**
     * 接口返回code
     */
    apiCode?: number;
    /**
     * 接口状态码：20x 40x
     */
    apiStatus?: number;
    /**
     * 日志打印模块名
     */
    module?: string;
    /**
     * 日志打印方法名
     */
    method?: string;
    /**
     * 错误堆栈信息
     */
    error?: string;
    /**
     * 日志自定义说明信息
     */
    message: string;
    /**
     * 预留扩展字段
     */
    ext?: string;
}

export const DEBOUNCE_TIME = 100;

export const STACK_MAX = 5;
